import { api } from 'src/plugins/axios'
import { notify } from 'src/plugins/notify'
import { createQueryString, serializeObject } from 'src/utils'
import { initialState } from './state'

export default {
  fetch,
  fetchOrderTypes,
  fetchShippingMethods,
  fetchAffiliateOrderTypeOverrides,
  fetchOrderTypeOverrides,
  addNew,
  one,
  create,
  update,
  remove,
  clearAllForms,
  processOrder,
  createOrderType,
  updateOrderType,
  removeOrderType,
  createUserOverride,
  updateUserOverrides,
  removeUserOverrides,
  createCourseOverride,
  updateCourseOverrides,
  removeCourseOverrides,
  createAffiliateOverride,
  updateAffiliateOverrides,
  removeAffiliateOverrides,
  loadOrderDetailItems,
  authorizeBypass,
  getCustomerPaymentProfiles,
  updateOrderStatus,
  fetchSearchOrderTypes,
  updateItemAndShipping,
  setPaymentModalOrder
}

async function fetch ({ state, commit }, { pagination, filter, columns, customFilter, exportOptions }) {
  commit('isLoading')
  try {
    let query = createQueryString({ pagination, filter, columns, customFilter, exportOptions })
    let fieldQuery
    
    let finalSearchFields = _.pickBy(state.searchFields, v => {
        return v !== null && v !== '' && (typeof v === 'string' ? v.trim() !== '' : 1)
    })

    if (!_.isEmpty(finalSearchFields)) {
        fieldQuery = serializeObject({ searchFields: { ...finalSearchFields } })
    }
    
    let finalQuery = query + (fieldQuery ? '&' + fieldQuery : '')

    const { data: response } = await api.get('/orders/fetch/' + finalQuery)
    const { success, payload } = response
    commit('doneLoading')
    if (!success) throw response
    if (!exportOptions) commit('setList', { orders: payload.orders })
    // notify.respond(response)
    return response
  }
  catch (response) {
    console.log(response)
    commit('doneLoading')
    // notify.respond(response)
    return response
  }
}

async function setPaymentModalOrder ({ commit, state, dispatch }, { ORDER_ID, open = false }) {
  let { data } = await api.post('/orders/one', { ORDER_ID }),
      { success, payload } = data
  let existingInfo = JSON.parse(payload.data.ORDER_DATA).paymentInfo,
      items = existingInfo.items
  let pendingPayment = Object.assign(_.cloneDeep(initialState.pendingPayment), existingInfo)
  state.pendingPayment = pendingPayment

  // if(existingInfo.existingOrNew === 'later'){
  state.pendingPayment.wasPayLater = true
  // }
  state.pendingPayment.ORDER_ID = ORDER_ID
  state.pendingPayment.canAdd = false
  state.pendingPayment.readOnly = true
  state.pendingPayment.processing = false
  state.pendingPayment.adminBypass.authorized = false
  state.afterProcessCallback = function(){
    // Reload the details modal
    dispatch('one', { ORDER_ID })
  }
  /**
   * Reset admin override authorize
   */
  if(open) state.processPaymentModalOpen = true
}

async function fetchOrderTypes ({ commit, state }) {
  try {
    let include = []
    if(state.processPaymentModalOpen === true){
      include = state.pendingPayment.items.map(i => i.orderType)
      console.log(include)
    }
    const { data: response } = await api.get('/orders/fetchOrderTypes', { params: { include }})
    const { success, payload } = response
    if (!success) throw response
    commit('setOrderTypes', payload.map(item => item.ORDER_TYPE))
    return response
  } catch (response) {
    return response
  }
}

async function fetchSearchOrderTypes ({ commit }) {
  try {
    const { data: response } = await api.get('/orders/fetchOrderTypes')
    const { success, payload } = response
    if (!success) throw response
  commit('setSearchOrderTypes', payload.map(item => item.ORDER_TYPE))
    return response
  } catch (response) {
    return response
  }
}



async function fetchShippingMethods ({ commit, dispatch, state }, orderTypeId) {
  try {
    const { data: response } = await api.get('/orders/fetchShippingMethods', {
      params: {
        orderTypeId
      }
    })
    const { success, payload } = response
    if (!success) throw response
    commit('setOrderTypeOverrides', payload.orderTypeOverrides)
    return response
  } catch (response) {
    return response
  }
}

async function fetchOrderTypeOverrides ({ commit, dispatch, state }) {
  try {
    const { data: response } = await api.get('/orders/fetchOrderTypeOverrides?orderTypeId=' + state.orderTypeForm.ORDER_TYPE_ID)
    const { success, payload } = response
    if (!success) throw response
    commit('setOrderTypeOverrides', payload.orderTypeOverrides)
    return response
  } catch (response) {
    return response
  }
}

async function fetchAffiliateOrderTypeOverrides ({ commit, dispatch, state }, affiliateUserId) {
  try {
    const { data: response } = await api.get('/orders/fetchAffiliateOrderTypeOverrides?affiliateUserId=' + affiliateUserId)
    const { success, payload } = response
    if (!success) throw response
    commit('setOrderTypeOverrides', payload.orderTypeOverrides)
    return response
  } catch (response) {
    return response
  }
}

async function addNew ({ commit, dispatch, state }) {
  console.log('clearing')
  dispatch('clearAllForms')
  commit('openDetails', { mode: 'add' }, { root: true })
}

async function one ({ commit, dispatch, state }, options) {
  dispatch('clearAllForms')
  let { data } = await api.post('/orders/one', { ORDER_ID: options.ORDER_ID})
  let { payload, success } = data
  state.orderDetails.ORDER = payload.data
  state.orderDetails.ORDER.OVERRIDE_USER = payload.OVERRIDE_USER
  commit('detailsModalOpen', true)
}

async function update ({ commit, dispatch, state }, { LK_ORDER_STATUS = null, vm }) {
  const { ORDER_ID, NOTES} = state.orderDetails.ORDER
  let { data } = await api.post('/orders/update',  { ORDER_ID, NOTES, LK_ORDER_STATUS })
  let { message, success } = data
  if(success){
    commit('detailsModalOpen', false)
    vm.$root.$emit('refreshGrid:ordersGrid')
  }
  notify.respond(data)
}

async function create ({ commit, dispatch, state }) {
  const { orderForm } = state
  const form = {
    orderForm
  }
  try {
    const { data: response } = await api.post('/orders/create', { form })
    const { success } = response
    if (!success) throw response

    // commit('updateStudentForm', { field: 'STUDENT_ID', value: payload.STUDENT_ID })
    dispatch('fetch', {})

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function createOrderType ({ commit, dispatch, state }) {
  const orderTypeForm = { 
    ORDER_TYPE_NAME: state.orderTypeForm.ORDER_TYPE_NAME,
    PRICE: state.orderTypeForm.PRICE,
    MIN_AMOUNT: state.orderTypeForm.MIN_AMOUNT,
    MAX_AMOUNT: state.orderTypeForm.MAX_AMOUNT
  }

  try {
    const { data: response } = await api.post('/orders/createOrderType', { orderTypeForm })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypes', {})

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function updateOrderType ({ commit, dispatch, state }) {
  const { orderTypeForm } = state
  const form = {
    orderTypeForm
  }
  try {
    const { data: response } = await api.post('/orders/updateOrderType', { form })
    const { success } = response
    if (!success) throw response
    
    dispatch('fetchOrderTypes', {})

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function removeOrderType ({ commit, dispatch, state }) {
  const { ORDER_TYPE_ID } = state.orderTypeForm
  try {
    const { data: response } = await api.post('/orders/removeOrderType', { ORDER_TYPE_ID })
    const { success } = response
    if (!success) throw response
    
    dispatch('fetchOrderTypes', {})

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function remove ({ commit, dispatch, state }) {
  const { orderForm } = state
  const { ORDER_ID } = orderForm
  try {
    const { data: response } = await api.post('/orders/remove', { ORDER_ID })
    const { success } = response
    if (!success) throw response

    dispatch('fetch', {})
    commit('closeDetails', {}, { root: true })
    notify.respond(response)
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function removeUserOverrides ({ commit, dispatch, state }) {
  const orderTypeOverrideIds = state.selectedUserOverrides.map(userOverride => userOverride.ORDER_TYPE_OVERRIDE_ID)

  try {
    const { data: response } = await api.post('/orders/removeOrderTypeOverrides', { orderTypeOverrideIds })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})
    notify.respond(response)
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function removeCourseOverrides ({ commit, dispatch, state }) {
  const orderTypeOverrideIds = state.selectedCourseOverrides.map(courseOverride => courseOverride.ORDER_TYPE_OVERRIDE_ID)

  try {
    const { data: response } = await api.post('/orders/removeOrderTypeOverrides', { orderTypeOverrideIds })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})
    notify.respond(response)
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function removeAffiliateOverrides ({ commit, dispatch, state }) {
  const orderTypeOverrideIds = state.selectedAffiliateOverrides.map(affiliateOverride => affiliateOverride.ORDER_TYPE_OVERRIDE_ID)

  try {
    const { data: response } = await api.post('/orders/removeOrderTypeOverrides', { orderTypeOverrideIds })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})
    notify.respond(response)
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function createUserOverride ({ commit, dispatch, state }, userId) {
  const orderTypeOverride = {
    LK_ENTITY_ITEM_ID: userId,
    LK_ENTITY_ID: 1,
    ORDER_TYPE_ID: state.orderTypeForm.ORDER_TYPE_ID
  }
  try {
    const { data: response } = await api.post('/orders/createOrderTypeOverride', { orderTypeOverride })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function updateUserOverrides ({ commit, dispatch, state }) {
  const orderTypeOverrides = state.selectedUserOverrides
  
  const form = {
    orderTypeOverrides
  }

  try {
    const { data: response } = await api.post('/orders/updateOrderTypeOverrides', { form })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})
    notify.respond(response)
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function createCourseOverride ({ commit, dispatch, state }, courseId) {
  const orderTypeOverride = {
    LK_ENTITY_ITEM_ID: courseId,
    LK_ENTITY_ID: 2,
    ORDER_TYPE_ID: state.orderTypeForm.ORDER_TYPE_ID
  }
  try {
    const { data: response } = await api.post('/orders/createOrderTypeOverride', { orderTypeOverride })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function updateCourseOverrides ({ commit, dispatch, state }) {
  const orderTypeOverrides = state.selectedCourseOverrides
  
  const form = {
    orderTypeOverrides
  }

  try {
    const { data: response } = await api.post('/orders/updateOrderTypeOverrides', { form })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})
    notify.respond(response)
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function createAffiliateOverride ({ commit, dispatch, state }, userId) {
  const orderTypeOverride = {
    LK_ENTITY_ITEM_ID: userId,
    LK_ENTITY_ID: 9,
    ORDER_TYPE_ID: state.orderTypeForm.ORDER_TYPE_ID
  }
  try {
    const { data: response } = await api.post('/orders/createOrderTypeOverride', { orderTypeOverride })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})

    notify.respond(response)
    return response
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function updateAffiliateOverrides ({ commit, dispatch, state }) {
  const orderTypeOverrides = state.selectedAffiliateOverrides
  
  const form = {
    orderTypeOverrides
  }

  try {
    const { data: response } = await api.post('/orders/updateOrderTypeOverrides', { form })
    const { success } = response
    if (!success) throw response

    dispatch('fetchOrderTypeOverrides', {})
    notify.respond(response)
  } catch (response) {
    notify.respond(response)
    return response
  }
}

async function clearAllForms ({ commit }) {

}

async function getCustomerPaymentProfiles({ commit}, { USER_ID }){
  let { data } = await api.post('/payments/getCustomerProfile',{ USER_ID })
  let { success, payload, message } = data
  if(success){
    commit('setCustomerInformation', payload)
  }
  else{
    console.log(data)
    notify.create({message: message, type: 'negative'})
  }
}

async function processOrder ({ state, rootState, commit }, { user, total, payLater }) {
  let pendingPaymentClone = _.cloneDeep(state.pendingPayment)
  let lkStateID = pendingPaymentClone.billingAddress.state
  let mailingStateID = pendingPaymentClone.mailingAddress.state
  
  pendingPaymentClone.payLater = payLater

  if(lkStateID){
    let stateAbbr = _.find(rootState.states,{LK_STATE_ID:lkStateID})
    pendingPaymentClone.billingAddress.stateName = stateAbbr
  }

  if(mailingStateID){
    let stateAbbr = _.find(rootState.states,{LK_STATE_ID:lkStateID})
    pendingPaymentClone.mailingAddress.stateName = stateAbbr
  }

  // Get structure ready from state
  // Send request to make payment
  return await api.post('/payments/processOrder', { 
    isStudent: false,
    paymentInfo: pendingPaymentClone,
    total
  })
  .then( data => {
    if(state.afterProcessCallback){
      state.afterProcessCallback.call(null, data)
      state.pendingPayment.loadOrderTypes = true
      if(data.data.success) commit('updatePaymentCallback', null)
    }
    return data
  })
}

async function loadOrderDetailItems({state}){
  const { data } = await api.post('/orders/loadOrderDetailItems',{ORDER_ID: state.orderDetails.ORDER.ORDER_ID})
  state.orderDetails.items = _.map(data,i => {
    return {
      description: i.ORDER_DESCRIPTION,
      orderType: i.ORDER_TYPE_ID,
      price: i.PRICE,
      quantity: i.QUANTITY
    }
  })
  setTimeout(function(){
    state.orderDetails.loading = false
  },300)
}

async function authorizeBypass({ state, commit }){
  state.pendingPayment.adminBypass.authorizing = true
  const { data } = await api.post('/orders/authorizeBypass',{PASSWORD: state.pendingPayment.adminBypass.password})
  commit('handleAuthorizeBypassResponse', data)
}

async function updateOrderStatus({state},status){
  const {data} = await api.post('/orders/updateOrderStatus',status)
}

async function updateItemAndShipping({state, commit},{itemIndex, orderTypeId}){
  commit('updateItemFromType', { itemIndex: itemIndex, orderType: orderTypeId })
  commit('updateItemShippingMethodOptions', { itemIndex: itemIndex, orderTypeId: orderTypeId })
  // Select the first method if available
  let methods = state.pendingPayment.items[itemIndex].shippingMethodOptions
  if(methods && methods.length > 0){
    commit('updateItemShippingMethod', { itemIndex: itemIndex, shippingMethod: methods[0].value })
  }
  else{
    commit('updateItemShippingMethod', { itemIndex: itemIndex })
  }
}